import React from 'react'
import { useScrollDrift } from '../hooks/useScrollDrift'

interface Props {
  thin: string
  bold: string
  className?: string
}

/** Right-edge vertical section label. Uses writing-mode (real vertical layout
 *  box — no rotate-overflow), readable opacities, gold accent. Scroll-tracked:
 *  slides from the section's top to its bottom, clamped at both ends so it
 *  always starts/stops with the section content. Desktop only. */
const VerticalLabel: React.FC<Props> = ({ thin, bold, className = '' }) => {
  const { trackRef, labelRef } = useScrollDrift<HTMLDivElement, HTMLSpanElement>()
  return (
    <div
      ref={trackRef}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-y-0 right-2 lg:right-6 z-0 hidden lg:flex justify-center ${className}`}
    >
      <span
        ref={labelRef}
        className="vertical-label-in self-start translate-y-[var(--drift-y,0px)] [writing-mode:vertical-rl] rotate-180 whitespace-nowrap font-display text-3xl xl:text-4xl tracking-[0.35em] uppercase select-none will-change-transform"
      >
        <span className="font-thin text-white/25">{thin}</span>
        <span className="font-bold text-accent-gold/50">{bold}</span>
      </span>
    </div>
  )
}
export default VerticalLabel
